import Layout from '@/layout'

export const routerList = [
  {
    path: '/file',
    component: Layout,
    meta: {
      title: '资料',
      icon: 'icon-chanpinPIguanli-01'
    },
    // alwaysShow: true,
    children: [
      {
        path: '/file/index',
        component: () => import('@/views/File/Index'),
        name: 'FileIndex',
        meta: { title: '资料文件', affix: false }
      }
    ]
  }
]
